import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconDesktopSvg } from "./IconDesktopSvg.mjs";
const IconDesktop = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconDesktopSvg, ...svgProps }) });
export {
  IconDesktop
};
